<!--  -->
<template>
  <el-dialog
    :visible.sync="showAuditMask"
    :close-on-click-modal="false"
    width="800px"
    :show-close="false"
    append-to-body
  >
    <div class="e-title" slot="title">
      <span class="title-name">选择审批流程</span>
      <span @click="closeDialog" class="icon">
        <i class="el-icon-close"></i>
      </span>
    </div>
    <div class="e-content">
      <div>
        <new-swiper
          v-if="showAuditMask"
          :banners="approvalList"
          :name="'name'"
          :h="60"
          @getItemId="getItemPid"
        ></new-swiper>
      </div>
      <div class="process-wrap">
        <div
          class="process-item"
          v-for="(item, index) in approvalChain.auditNodeVOList"
          :key="index"
        >
          <div class="top">
            <i class="arrow-right-white" v-if="index > 0"></i>
            <i class="line line-left"></i>
            <span class="num-circle">{{ index + 1 }}</span>
            <i class="line line-right"></i>
            <i class="arrow-right"></i>
          </div>
          <div class="bottom">
            <ul>
              <li v-for="(list, index1) in item.auditNodeMemberVOList" :key="index1">
                <div>{{ list.nodeMemberName }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <div class="e-btn e-close pointer">关闭</div> -->
      <div class="btn submit-btn" @click="chooseApproval">选择此流程</div>
    </div>
  </el-dialog>
</template>

<script>
import NewSwiper from './newSwiper';
import Api from '@/modules/projectA/api/purchase';
export default {
  props: {
    approvalList: {
      type: Array,
      default: () => [],
    },
    showAuditMask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approvalChain: {},
    };
  },
  watch: {
    showAuditMask(newVal) {
      if (newVal) {
        this.approvalChain = {};
      }
    },
  },
  components: {
    NewSwiper,
  },

  computed: {},

  methods: {
    closeDialog() {
      this.$emit('update:showAuditMask', false);
    },
    // 选择审批item
    async getItemPid(val) {
      let res = await Api.approveDetail({ auditId: val });
      if (res.code == 200) {
        this.approvalChain = res.data;
      }
    },
    // 选择审批流
    chooseApproval() {
      if (Object.keys(this.approvalChain).length === 0) {
        this.$message.warning('请选择审批流');
        return;
      }
      this.closeDialog();
      this.$emit('getApprovalChain', this.approvalChain);
    },
  },
};
</script>
<style lang="scss" scoped>
.e-content {
  ul {
    .address-item {
      border: 1px solid #d9d9d9;
      border-bottom: none;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #0064c8;
      cursor: pointer;
      .item-r {
        border-bottom: 1px solid transparent;

        &:hover {
          border-bottom: 1px solid #0064c8;
        }
      }
      .line {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .margin-l10 {
        margin-left: 10px;
      }
      &:last-child {
        border-bottom: 1px solid #d9d9d9;
      }
      .right-icon {
        width: 16px;
        height: 16px;
        margin: 0 12px 0 16px;
      }
      .item-txt {
        color: #333;
        font-size: 14px;
      }
      .with-600 {
        width: 600px;
      }
      .item-l {
        font-size: 0;
        p {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 14px;
          line-height: 1;
          &:first-child {
            margin-bottom: 12px;
          }
          ::v-deep .el-radio {
            margin-right: 10px;
          }
        }
        .no-show {
          ::v-deep.el-radio__label {
            display: none;
          }
        }
      }
    }
  }
  .default-icon {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    background: #2587ff;
    color: #fff;
    text-align: center;
    font-size: 12px;
    border-radius: 4px;
    padding: 0 4px;
    margin-right: 4px;
  }
  .margin-l44 {
    margin-left: 25px;
  }
  .is-choose {
    border-bottom: 1px solid #0064c8;
  }
  .process-wrap {
    display: flex;
    margin: 40px 25px;
    text-align: center;
    overflow: auto;
  }
  .process-item {
    .top {
      font-size: 0;
      display: flex;
      // justify-content: center;
      align-items: center;
      .num-circle {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        background: #2587ff;
        font-size: 14px;
        color: #fff;
      }
      .line {
        display: inline-block;
        width: 50px;
        height: 4px;
        background: #2587ff;
      }
    }
    .bottom {
      width: 125px;
      height: 134px;
      overflow-y: auto;
      margin-top: 12px;
      ul {
        li {
          line-height: 1;
          color: #666;
          font-size: 14px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .invoice-list {
    margin: 20px;
    ul {
      border: 1px solid #d9d9d9;
      li {
        padding: 0 20px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 44px;
        border-bottom: 1px solid #d9d9d9;
        &:last-child {
          border-bottom: none;
        }
        .pointer {
          color: #0064c8;
          cursor: pointer;
        }

        .left {
          display: flex;
          align-items: center;
          .invoice-general {
            width: 100px;
            height: 20px;
            background-color: #e8efff;
            color: #2587ff;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            margin-left: 4px;
          }
          .invoice-special {
            width: 100px;
            height: 20px;
            background: rgba(234, 146, 0, 0.1);
            color: #ea9200;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            margin-left: 4px;
          }
          .companyName {
            margin-left: 4px;
            width: 337px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          ::v-deep .el-radio__label {
            display: none;
          }
        }

        .right {
          .edit {
            margin-right: 20px;
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
          .delete {
            color: #f0250f;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #f0250f;
            }
          }
        }
      }
    }
  }
}
::v-deep .el-dialog {
  margin-top: 0 !important;
  top: 50%;
  transform: translateY(-50%);
}
::v-deep .el-dialog__footer {
  display: flex;
  justify-content: center;
  .el-button {
    border-radius: 0;
    min-width: 80px;
    padding: 0;
    height: 30px;
    line-height: 28px;
    font-size: 14px;
  }
  .btn {
    min-width: 80px;
    padding: 0 10px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    cursor: pointer;
  }
  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
::v-deep.el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .e-title {
    display: flex;
    justify-content: space-between;
    .icon {
      cursor: pointer;
      .el-icon-close:hover {
        -webkit-appearance: none;
        color: #2587ff;
      }
    }
    .title-name {
      color: #333;
      font-size: 14px;
      display: flex;
      align-items: center;
      img {
        margin-right: 10px;
        width: 18px;
        height: 20px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
</style>
